import { Box } from "@chakra-ui/react";

const BlurSection = (props) => {
  const blurOverlayStyle = {
    position: "absolute",
    bottom: props?.bottom || 0,
    right: props?.right || 0,
    height: props?.height || "100%",
    pointerEvents: "none",
    width: props?.width || "28.5%",
    background:
      "linear-gradient(to right, transparent 0%, rgba(255,255,255,0.2) 30%, rgba(255,255,255,0.6) 100%)",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
    zIndex: 1000,
  };

  // const gradientOverlayStyle = {
  //   position: "absolute",
  //   top: 0,
  //   right: 0,
  //   height: "100%",
  //   pointerEvents: "none",
  //   width: "25%",
  //   background:
  //     "linear-gradient(to right, transparent 0%, rgba(240,240,240,0.3) 50%, rgba(240,240,240,0.5) 100%)",
  //   filter: "blur(2px)",
  //   zIndex: 1001,
  // };
  return (
    // <Box>
      <Box style={blurOverlayStyle} />
    // </Box>
  );
};

export default BlurSection;
